import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledButtonDropdown
} from "reactstrap";

import PropTypes from "prop-types";
import { ROW_PER_PAGINATION_OPTIONS } from "@src/utility/constants";
import ReactPaginate from "react-paginate";
import useWindowSize from "@views/common/hooks/use-window-size";

// Custom Component

const Paginate = ({
    count,
    handlePageChange,
    currentPage,
    limit = null,
    handleLimit = (limit) => limit,
    paginationRowsPerPageOptions = ROW_PER_PAGINATION_OPTIONS,
    className = ""
}) => {
    const { isMobileView } = useWindowSize();
    const rangeDisplayed = !isMobileView ? 1 : 0;
    return (
        <span id="paginate" className={className}>
            <UncontrolledButtonDropdown className="row-per-page mx-1" data-cy="pagination-limit">
                <DropdownToggle className="black-icon" caret>{limit}</DropdownToggle>
                <DropdownMenu>
                    {paginationRowsPerPageOptions.map((item, index) => (
                        <DropdownItem
                            key={index}
                            data-cy={item}
                            onClick={() => handleLimit(item)}
                            active={Number(limit) === item}>
                            {item}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </UncontrolledButtonDropdown>
            <ReactPaginate
                nextLabel={<i className="mdi mdi-chevron-right"/>}
                pageCount={Math.ceil(count / limit)}
                breakLabel="..."
                previousLabel={<i className="mdi mdi-chevron-left"/>}
                pageRangeDisplayed={rangeDisplayed}
                marginPagesDisplayed={rangeDisplayed}
                activeClassName="active"
                pageClassName="page-item"
                breakClassName="page-item"
                forcePage={currentPage !== 0 ? currentPage - 1 : 0}
                pageLinkClassName="page-link"
                nextLinkClassName="page-link"
                breakLinkClassName="page-link"
                previousLinkClassName="page-link"
                onPageChange={(page) => handlePageChange(page.selected + 1)}
                nextClassName="page-item next-item"
                previousClassName="page-item prev-item"
                containerClassName="pagination react-paginate"/>
        </span>
    );
};

Paginate.propTypes = {
    count                       : PropTypes.number.isRequired,
    handlePageChange            : PropTypes.func.isRequired,
    currentPage                 : PropTypes.number.isRequired,
    limit                       : PropTypes.number,
    handleLimit                 : PropTypes.func,
    paginationRowsPerPageOptions: PropTypes.array
};

export default Paginate;
